module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp1-9951e9983bcaf81bce3e1cea5b5ad26f.jpg";